/*
 * Where: src/features/top/components/ServiceHeroSection.js
 * What: Hero section for top page introduction.
 * Why: Isolate top-page specific UI in feature scope.
 */
import React from 'react';

function ServiceHeroSection({ hero }) {
    return (
        <section className="hero-panel">
            <p className="hero-badge">{hero.badge}</p>
            <h1>{hero.title}</h1>
            <p className="hero-description">{hero.description}</p>
        </section>
    );
}

export default ServiceHeroSection;
